import React from 'react'
import styles from './styles.module.scss'

export const Image = React.memo(
  ({ src, alt }: { src: string; alt: string }) => (
    <img src={src} alt={alt} className={styles.image} />
  )
)
